import { Box, MantineProvider } from '@mantine/core';
import { MantineReactTable } from 'mantine-react-table';
import TableDetail from './TableDetail';
// import '@mantine/core/styles.css';
// import '@mantine/dates/styles.css';
// import 'mantine-react-table/styles.css';

const MantineGrid = ({
  columns,
  data,
  columnsDetail,
  enableTableDetail = false,
  enablePagination = true,
  subRows = '',
}) => {
  console.log('grid data', data);
  // Prilagodjivanje naziva atributa ovoj komponenti

  const _columns = columns.map((column) => ({
    ...column,
    Cell: column.renderCell,
    accessorKey: column.field,
    header: column.headerName,
  }));
  console.log('_columns', _columns);
  // Kolone za grid unutar reda
  const _columnsDetait = columnsDetail?.map((column) => ({
    ...column,
    Cell: column.renderCell,
    accessorKey: column.field,
    header: column.headerName,
  }));

  return (
    <MantineProvider>
      <MantineReactTable
        columns={_columns}
        data={data}
        enablePagination={enablePagination}
        enableStickyHeader
        mantineTableContainerProps={{
          style: { minHeight: '500px' },
        }}
        // Opcija za grid unutar reda, potrebno je da objekat u data sadrzi i listu sa nazivom subRow
        {...(enableTableDetail
          ? {
              renderDetailPanel: ({ row }) => (
                <Box
                  style={{
                    width: 'calc( 100% - 120px )',
                    paddingLeft: '120px',
                  }}
                >
                  <TableDetail
                    columns={_columnsDetait}
                    data={row.original[subRows]}
                  />
                </Box>
              ),
            }
          : {})}
      />
    </MantineProvider>
  );
};

export default MantineGrid;
